export const environment = {
  production: true,
  env: 'staging',
  apiPath: 'https://portal.ed.energy',
  assetsPath: 'https://assets.ed.energy',
  firebaseDatabase: null,
  firebaseConfig: {
    apiKey: 'AIzaSyCFZBpYvAQFpq6BiAL_W8xbbSNKTxVFies',
    authDomain: 'energy-dynamics-staging.firebaseapp.com',
    databaseURL: 'https://energy-dynamics-staging.firebaseio.com',
    projectId: 'energy-dynamics-staging',
    storageBucket: 'energy-dynamics-staging.appspot.com',
    messagingSenderId: '660228252764',
    appId: '1:660228252764:web:c0b93c080dd2ae6e85b299',
    measurementId: 'G-BW6LVHXJ21'
  },

};
